import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import "./styles/globals.css";
import { AppRouter } from "./app/router";
import { AuthProvider } from "./contexts/AuthContext";

// Host-routed shell. Which shell renders is decided inside AppRouter based on
// window.location.hostname — virtualdesk.ai (marketing), onboarding.* (wizard),
// app.* (platform admin), or <code>.virtualdesk.ai (tenant).
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppRouter />
        <Toaster theme="dark" position="top-right" richColors closeButton />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
